import React, { useState } from 'react';
import { Button, Icon, Input } from '@tviklax/ui-components';
import {
    PageContainer,
    PageHeader,
    Title,
    Breadcrumbs,
    Card,
    DescriptionSection,
    SectionTitle,
    SectionText,
    FormSection,
    FormActions,
    EyeButton,
} from './ChangePassword.styles';

export const ChangePassword: React.FC = () => {
    const [showCurrent, setShowCurrent] = useState(false);
    const [showNew, setShowNew] = useState(false);
    const [showConfirm, setShowConfirm] = useState(false);

    return (
        <PageContainer>
            <PageHeader>
                <Title>Password</Title>
                <Breadcrumbs>
                    Home <Icon name="ChevronRight" size={14} /> <span>Change password</span>
                </Breadcrumbs>
            </PageHeader>

            <Card>
                <DescriptionSection>
                    <SectionTitle>Change Password</SectionTitle>
                    <SectionText>Update your password here</SectionText>
                </DescriptionSection>

                <FormSection>
                    <Input
                        label="Current Password"
                        placeholder="Enter current password"
                        type={showCurrent ? 'text' : 'password'}
                        endAdornment={
                            <EyeButton onClick={() => setShowCurrent(!showCurrent)} type="button">
                                <Icon name={showCurrent ? "EyeOff" : "Eye"} size={18} />
                            </EyeButton>
                        }
                    />

                    <Input
                        label="New Password"
                        placeholder="Enter new password"
                        type={showNew ? 'text' : 'password'}
                        endAdornment={
                            <EyeButton onClick={() => setShowNew(!showNew)} type="button">
                                <Icon name={showNew ? "EyeOff" : "Eye"} size={18} />
                            </EyeButton>
                        }
                    />

                    <Input
                        label="Confirm Password"
                        placeholder="Enter confirm password"
                        type={showConfirm ? 'text' : 'password'}
                        endAdornment={
                            <EyeButton onClick={() => setShowConfirm(!showConfirm)} type="button">
                                <Icon name={showConfirm ? "EyeOff" : "Eye"} size={18} />
                            </EyeButton>
                        }
                    />

                    <FormActions>
                        <Button>Save</Button>
                        <Button variant="soft">Reset</Button>
                    </FormActions>
                </FormSection>
            </Card>
        </PageContainer>
    );
};
